module.exports = __webpack_public_path__ + "static/media/ic_AI_video@2x.b8a69cb4.png";